<template>
  <v-container class="px-5">
    <v-row>
      <v-col cols="12" class="mt-12">
        <p class="orange--text">
          <v-icon color="warning">
            report_problem
          </v-icon>
          <b>
            {{ $t("downloads.main.important") }}
          </b>
        </p>
      </v-col>
      <v-col cols="12" class="pt-0">
        <span class="lighten-4 grey--text">
          {{ $t("downloads.main.important_message") }}
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-data-table
            :headers="headers"
            :items="files"
            :loading="loading"
            :page.sync="pagination.page"
            :items-per-page.sync="pagination.itemsPerPage"
            :sort-by.sync="pagination.sortBy"
            :sort-desc.sync="pagination.sortDesc"
          >
            <template v-if="files.length" v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>
                    <span>
                      <b>
                        {{ getFileName(item.filename || "") }}
                      </b>
                    </span>
                    <span class="darken-2 grey--text">
                      {{ getFileExt(item.filename || "") }}
                    </span>
                    <span class="darken-2 grey--text">
                      •
                    </span>
                    <span class="darken-2 grey--text">
                      {{ `${(item.size / 1000000.0).toFixed(2)} MB` }}
                    </span>
                  </td>
                  <td>
                    {{ item.created_at | moment("lll") }}
                  </td>
                  <td class="text-center">
                    <v-btn
                      v-if="item.status === 'success'"
                      @click="
                        downloadFile({
                          id: item.id,
                          filename: item.filename,
                          orgId: item.organization_id
                        })
                      "
                      icon
                    >
                      <v-icon>arrow_downward</v-icon>
                    </v-btn>
                    <v-tooltip v-else left color="black" class="caption">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          :color="getIconByStatus(item.status).color"
                        >
                          {{ getIconByStatus(item.status).icon }}
                        </v-icon>
                      </template>
                      <span>{{ getIconByStatus(item.status).title }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";

export default {
  name: "Downloads",
  layout: "Dashboard",
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        itemsLength: 0,
        itemsPerPage: 25,
        itemsPerPageOptions: [
          { value: 5, text: 5 },
          { value: 10, text: 10 },
          { value: 25, text: 25 },
          { value: 100, text: 100 }
        ],
        sortBy: "created_at",
        sortDesc: true
      },
      headers: [
        {
          text: this.$t("downloads.table.exported_file"),
          value: "filename",
          align: "left",
          sortable: true,
          class: "blue--text text--darken-4"
        },
        {
          text: this.$t("downloads.table.date"),
          value: "created_at",
          align: "left",
          sortable: true,
          class: "blue--text text--darken-4"
        },
        {
          text: this.$t("downloads.table.download"),
          value: "download_button",
          align: "left",
          sortable: false,
          class: "blue--text text--darken-4"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      file: state => state.downloads.file
    }),
    ...mapGetters({
      user: "auth/user",
      files: "downloads/files"
    })
  },
  async created() {
    this.loading = true;
    await this.getFiles();
    this.loading = false;
  },
  mounted() {},
  methods: {
    ...mapActions({
      getFiles: "downloads/getFiles",
      getFileAction: "downloads/getFile"
    }),
    ...mapMutations({
      setFile: "downloads/setFile"
    }),
    getFileExt(filename) {
      if (filename.includes("xlsx")) {
        return "XLSX";
      }
      return "CSV";
    },
    getFileName(filename) {
      return filename.slice(0, filename.lastIndexOf(".")) || filename;
    },
    getIconByStatus(status) {
      if (status === "queue") {
        return {
          icon: "pause",
          color: "gray",
          title: this.$t("downloads.status.queue")
        };
      }
      if (status === "processing") {
        return {
          icon: "hourglass_empty",
          color: "gray",
          title: this.$t("downloads.status.processing")
        };
      }
      return {
        icon: "error",
        color: "error",
        title: this.$t("downloads.status.error")
      };
    },
    async downloadFile(payload) {
      const { id, filename, orgId } = payload;

      await this.getFileAction({ file_id: id, orgId });

      if (this.file) {
        const file = new Blob([this.file]);
        const downloadUrl = window.URL.createObjectURL(file);

        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = filename;

        document.body.appendChild(link);
        link.click();

        // Cleanup - remove the link from the body
        document.body.removeChild(link);
      }

      this.setFile({});
    }
  }
};
</script>

<style></style>
